import { selectBillingByUserIdQueryOptions } from "@/features/admin/api/selectBillingByUserId";
import { selectProfileByIdQueryOptions } from "@/features/profile/api/selectProfile";
import type { QueryClient } from "@tanstack/react-query";

export async function loadAdminUserProfile(queryClient: QueryClient, userId: string) {
    const profile = await queryClient.ensureQueryData(selectProfileByIdQueryOptions(userId));
    await queryClient.ensureQueryData(selectBillingByUserIdQueryOptions(userId));
    return { profile };
}

/** Map a profile's roles to the users-hub tab that should host their detail panel. */
export function adminUsersSegmentForProfile(
    profile:
        | {
              roles?: string[] | null;
              organisations?: { role: string }[] | null;
          }
        | null
        | undefined
): "patients" | "clinicians" | "managers" | "secretaries" | "admins" {
    const roles = new Set(
        [...(profile?.roles ?? []), ...(profile?.organisations?.map((org) => org.role) ?? [])]
            .filter(Boolean)
            .map((role) => role.toUpperCase())
    );

    if (roles.has("ADMIN")) return "admins";
    if (roles.has("CLINICIAN")) return "clinicians";
    if (roles.has("MANAGER")) return "managers";
    if (roles.has("SECRETARY")) return "secretaries";
    return "patients";
}
